<template>
  <div>
    <h1 class="mb-4 font-bold text-3xl">
      KRS &amp; KHS Report
    </h1>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <div class="w-1/2 md:mb-7 md:w-1/6">
        <label
          for="verification_date_sdate"
          class="text-sm form-label">Tanggal Verifikasi:</label>
        <flat-pickr
          id="verification_date_sdate"
          v-model="form.verification_date_sdate"
          class="py-3 px-6 mr-2 w-full rounded shadow focus-ring"
          placeholder="YYYY-MM-DD" />
      </div>
      <div class="w-1/2 md:mb-7 md:w-1/6">
        <label for="krs" class="text-sm form-label">KRS:</label>
        <select
          id="krs"
          v-model="form.krs_verif"
          class="form-select">
          <option
            :value="null"
            default
            class="text-center">
            ALL
          </option>
          <option value="0" class="text-center">
            BLM VERIF
          </option>
          <option value="1" class="text-center">
            VERIF
          </option>
        </select>
      </div>
      <div class="w-1/2 md:mb-7 md:w-1/6">
        <label for="khs" class="text-sm form-label">KHS:</label>
        <select
          id="khs"
          v-model="form.khs_verif"
          class="form-select">
          <option
            :value="null"
            default
            class="text-center">
            ALL
          </option>
          <option value="0" class="text-center">
            BLM VERIF
          </option>
          <option value="1" class="text-center">
            VERIF
          </option>
        </select>
      </div>
      <search-filter
        v-model="form.search"
        placeholder="Cari Nama atau NIM..."
        :show-dropdown="false"
        class="flex-shrink-0 w-3/6 max-w-md"
        @reset="reset" />
      <div class="flex flex-shrink-0 gap-2 mt-2 w-full">
        <div class="w-1/2 md:w-1/4">
          <label
            for="approval_status"
            class="text-sm form-label">Persetujuan Pembayaran:</label>
          <select
            id="approval_status"
            v-model="form.approval_status"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option :value="999" class="text-center">
              N/A
            </option>
            <option
              v-for="option in approvalStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select>
        </div>
        <div class="w-1/2 md:w-1/4">
          <label
            for="payment_status"
            class="text-sm form-label">Status Pembayaran:</label>
          <select
            id="payment_status"
            v-model="form.payment_status"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option :value="999" class="text-center">
              N/A
            </option>
            <option
              v-for="option in paymentStatusOptions"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select>
        </div>
        <div class="w-1/2 md:w-1/4">
          <label
            for="scholarship_period"
            class="text-sm form-label">Periode Pembayaran:</label>
          <select
            id="scholarship_period"
            v-model="form.scholarship_period"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option value="GANJIL">
              GANJIL
            </option>
            <option value="GENAP">
              GENAP
            </option>
          </select>
        </div>
        <div class="w-full md:w-1/4">
          <label
            for="scholarship_year"
            class="text-sm form-label">Tahun Pembayaran:</label>
          <select
            id="scholarship_year"
            v-model="form.scholarship_year"
            class="form-select">
            <option
              :value="null"
              default
              class="text-center">
              ALL
            </option>
            <option value="2023">
              2023
            </option>
            <option value="2024">
              2024
            </option>
          </select>
        </div>
        <a
          :href="urlExportExcel"
          class="md:mt-7 btn-green"
          as="button"
          title="Download data dalam format .xlsx"><i class="fas fa-file-excel" /> Export Excel</a>
      </div>
    </div>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-left">
              Nama Mahasiswa
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Nama Kampus
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kota Studi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tahun Ajaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Semester
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              KRS
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              KHS
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Persetujuan Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Status Pembayaran
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Tahun Beasiswa
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Periode Beasiswa
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Verification Date
            </th>
            <th class="px-6 pt-6 pb-4 text-left whitespace-normal break-words">
              Created At
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in studentReports.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.mahasiswa_name }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.mahasiswa_universitas }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.kota_studi }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.school_year }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.school_semester }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.krs_verified_status }}
                {{ row.krs_verif_fdate }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.khs_verified_status }}
                {{ row.khs_verif_fdate }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.approval_status }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.payment_status }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.scholarship_year }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.scholarship_period }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.verification_date }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('admin.krs.show', row.id)">
                {{ row.created_at }}
              </inertia-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="studentReports.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { router, Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'KRS' },

  components: {
    Pagination,
    SearchFilter,
    flatPickr,
    'inertia-link': Link,
  },

  layout: Layout,

  props: {
    filters: Object,
    studentReports: Object,
    approvalStatusOptions: Array,
    paymentStatusOptions: Array,
  },

  data () {
    return {
      form: {
        search: this.filters.search,
        scholarship_period: this.filters.scholarship_period,
        scholarship_year: this.filters.scholarship_year,
        approval_status: this.filters.approval_status,
        payment_status: this.filters.payment_status,
        verification_date_sdate: this.filters.verification_date_sdate,
        krs_verif: this.filters.krs_verif,
        khs_verif: this.filters.khs_verif,
      },
    }
  },

  computed: {
    urlExportExcel () {
      return (
        '/student_reports/export?' +
        new URLSearchParams(pickBy(this.form)).toString()
      )
    },
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get(this.route('admin.krs.index'), pickBy(this.form), {
          preserveState: true,
        })
      }, 150),
    },
  },

  methods: {
    reset () {
      this.form = mapValues(this.form, () => null)
    },
    is_verified_icon (val) {
      return val ? 'fas fa-check-circle' : 'fas fa-times-circle'
    },
    exportExcel () {
      // fetch(this.route('student_reports.export'), pickBy(this.form))
    },
  },
}
</script>
